exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-main .main-bd .el-row[data-v-ed29621a]{padding:10px 0}.grid-content[data-v-ed29621a]{text-align:center}.grid-image[data-v-ed29621a]{width:45px;height:45px;border-radius:15%}.row-bg[data-v-ed29621a]{padding:5px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed29621a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/digitizedcampusConfigure.vue
// module id = 2106
// module chunks = 0